'use client';

import { c as _c } from "react/compiler-runtime";
import * as DialogPrimitive from '@radix-ui/react-dialog';
import * as React from 'react';
import Close from '../../icons/Close';
import { cn } from '../../utils/cn';
import { Button } from '../_base/Button';
import { ScrollFade } from '../feedback/ScrollFade';
function Dialog(t0) {
  const $ = _c(4);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] !== props) {
    t1 = <DialogPrimitive.Root data-slot="dialog" {...props} />;
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function DialogTrigger(t0) {
  const $ = _c(4);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] !== props) {
    t1 = <DialogPrimitive.Trigger data-slot="dialog-trigger" {...props} />;
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function DialogPortal(t0) {
  const $ = _c(4);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] !== props) {
    t1 = <DialogPrimitive.Portal data-slot="dialog-portal" {...props} />;
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function DialogClose(t0) {
  const $ = _c(4);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] !== props) {
    t1 = <DialogPrimitive.Close data-slot="dialog-close" {...props} />;
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function DialogOverlay(t0) {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-50 bg-black/50 backdrop-blur-lg", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <DialogPrimitive.Overlay data-slot="dialog-overlay" className={t1} {...props} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
function DialogContent(t0) {
  const $ = _c(19);
  let children;
  let className;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      className,
      children,
      closeOnEscape: t1,
      fullScreenMobile: t2,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
    $[4] = t1;
    $[5] = t2;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
    t1 = $[4];
    t2 = $[5];
  }
  const closeOnEscape = t1 === undefined ? false : t1;
  const fullScreenMobile = t2 === undefined ? false : t2;
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <DialogOverlay />;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = fullScreenMobile && "max-md:data-[state=open]:slide-in-from-bottom max-md:data-[state=closed]:slide-out-to-bottom";
  const t5 = !fullScreenMobile && "max-md:data-[state=closed]:zoom-out-95 max-md:data-[state=open]:zoom-in-95";
  const t6 = fullScreenMobile ? "max-md:inset-0 max-md:h-full max-md:max-h-full max-md:w-full max-md:max-w-full max-md:rounded-none" : "max-md:top-[50%] max-md:left-[50%] max-md:max-h-[min(750px,90vh)] max-md:w-full max-md:max-w-[calc(100%-2rem)] max-md:translate-x-[-50%] max-md:translate-y-[-50%] max-md:rounded-2xl";
  let t7;
  if ($[7] !== className || $[8] !== t4 || $[9] !== t5 || $[10] !== t6) {
    t7 = cn("bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 px-lg py-lg fixed z-50 grid overflow-x-hidden overflow-y-auto border shadow-lg transition-none duration-200 outline-none", t4, t5, "md:data-[state=closed]:zoom-out-95 md:data-[state=open]:zoom-in-95", t6, "md:top-[50%] md:left-[50%] md:max-h-[min(750px,90vh)] md:w-full md:max-w-lg md:translate-x-[-50%] md:translate-y-[-50%] md:rounded-2xl", "has-[:where([data-slot=\"dialog-footer\"])]:pb-0 has-[:where([data-slot=\"dialog-header\"])]:pt-0", className);
    $[7] = className;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== closeOnEscape) {
    t8 = event => {
      const target = event.target;
      const focusedSearch = target instanceof HTMLInputElement && target.type === "search" ? target : null;
      const hadSearchText = focusedSearch !== null && focusedSearch.value !== "";
      if (hadSearchText) {
        Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, "value")?.set?.call(focusedSearch, "");
        focusedSearch.dispatchEvent(new Event("input", {
          bubbles: true
        }));
      }
      if (!closeOnEscape || hadSearchText) {
        event.preventDefault();
      }
    };
    $[12] = closeOnEscape;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== children || $[15] !== props || $[16] !== t7 || $[17] !== t8) {
    t9 = <DialogPortal data-slot="dialog-portal">{t3}<DialogPrimitive.Content data-slot="dialog-content" className={t7} onEscapeKeyDown={t8} {...props}>{children}</DialogPrimitive.Content></DialogPortal>;
    $[14] = children;
    $[15] = props;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  return t9;
}
function DialogHeader(t0) {
  const $ = _c(14);
  let children;
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      children,
      showCloseButton: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
    $[4] = t1;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
    t1 = $[4];
  }
  const showCloseButton = t1 === undefined ? true : t1;
  let t2;
  if ($[5] !== className) {
    t2 = cn("gap-xs bg-popover py-lg sticky top-0 isolate z-10 mb-0! flex flex-col text-center sm:text-left", className);
    $[5] = className;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== showCloseButton) {
    t3 = showCloseButton && <DialogPrimitive.Close data-slot="dialog-close" className="top-lg absolute right-0 -translate-y-[4px]" asChild={true}><Button variant="ghost" size="icon" data-testid="dialog-close-button" aria-label="Close"><Close /></Button></DialogPrimitive.Close>;
    $[7] = showCloseButton;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== children || $[10] !== props || $[11] !== t2 || $[12] !== t3) {
    t4 = <div data-slot="dialog-header" className={t2} {...props}>{children}{t3}</div>;
    $[9] = children;
    $[10] = props;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
}

// `-mx-lg px-lg` cancels DialogContent's padding so the solid background and the fade reach both
// dialog edges, then re-insets the content. Without it the gutters stay uncovered and content
// scrolling under the footer shows through them.
function DialogFooter(t0) {
  const $ = _c(11);
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = cn("py-lg bg-popover -mx-lg px-lg sticky bottom-0 z-10 flex flex-col-reverse gap-2 sm:flex-row sm:justify-between", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ScrollFade className="from-popover" />;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== children || $[8] !== props || $[9] !== t1) {
    t3 = <div data-slot="dialog-footer" className={t1} {...props}>{t2}{children}</div>;
    $[7] = children;
    $[8] = props;
    $[9] = t1;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}
function DialogTitle(t0) {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("text-title-xs text-popover-foreground pr-12", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <DialogPrimitive.Title data-slot="dialog-title" className={t1} {...props} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
function DialogDescription(t0) {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("text-muted-foreground text-2xs", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <DialogPrimitive.Description data-slot="dialog-description" className={t1} {...props} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
export { Dialog, DialogClose, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogOverlay, DialogPortal, DialogTitle, DialogTrigger };